import { isDevMode, makeEnvironmentProviders } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

import { DEFAULT_LANG, SUPPORTED_LANGS } from './i18n.config';
import { TranslocoHttpLoader } from './transloco-loader';

export function provideI18n() {
    return makeEnvironmentProviders([
        provideTransloco({
            config: {
                availableLangs: SUPPORTED_LANGS.map((l) => l.id),
                defaultLang: DEFAULT_LANG,
                fallbackLang: DEFAULT_LANG,
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
                missingHandler: {
                    useFallbackTranslation: true,
                    logMissingKey: isDevMode(),
                },
            },
            loader: TranslocoHttpLoader,
        }),
        provideTranslocoPersistLang({
            storage: {
                useValue: typeof localStorage !== 'undefined' ? localStorage : ({} as Storage),
            },
            storageKey: 'ast.lang',
        }),
    ]);
}
